import colors from "../colors";

export const getQueryLabels = (query, map, queryKey) => {
  const queryKeys = Object.keys(query)
  let results = []

  if(queryKeys && queryKeys.length > 0){
    for (let index = 0; index < queryKeys.length; index++) {
      const key = queryKeys[index];
      if(key === queryKey){
        const value = query[key]

        if(typeof value === 'object' && value.length > 0){
          // Multi value
          for (let index1 = 0; index1 < value.length; index1++) {
            const id = value[index1];
            if(map[id]) results.push(map[id])
          }
        } else {
          // Single value
          if(map[value]) results.push(map[value])
        }
      }
    }
  }

  return results
}

const _COLORS = [colors.green, '#52BAE2', '#FF5448', '#7171EF', '#FFC020', '#753A00'];
const LANGUAGE_FROM_API = 'id'
const DEFAULT_TOTAL = 50

export const getChartData = (queryLabels, statisticData, systemData, language) => {
  let data = []
  let COLORS = [..._COLORS]

  if(queryLabels && queryLabels.length > 0){
    const selectedData = statisticData?.data?.filter(d => queryLabels.includes(d.name))
    const others = statisticData?.data?.filter(d => !queryLabels.includes(d.name))

    if(others && others.length > 0){
      let total = 0
      for (let index = 0; index < others.length; index++) {
        const element = others[index];
        total += element.value
      }
      const othersMerged = [{
        name: 'Others',
        value: total
      }]

      data = [...selectedData, ...othersMerged]
      COLORS[data.length-1] = '#aaa'
    }
  } else {
    if(statisticData){
      data = generateDataIds(statisticData, systemData, language)
      COLORS = [..._COLORS]
    }
  }

  return {
    data: {
      data,
      total: statisticData?.total ? statisticData.total : DEFAULT_TOTAL
    },
    COLORS
  }
}

export function generateDataIds(statisticData, systemData, language) {
  let result = []
  let others = {
    id: undefined,
    name: "Others",
    value: 0
  }

  if(statisticData && systemData){
    if(systemData.length > 0){
      let total = 0
      let withOthers = false

      for (let index = 0; index < systemData.length; index++) {
        const type = systemData[index];
        const value = statisticData.data?.find(o => o.name === type.name[LANGUAGE_FROM_API])?.value

        if(value){
          result.push({
            id: type.id,
            name: type.name[language],
            value
          })

          total += value
        } else {
          withOthers = true
        }
      }

      if(withOthers){
        others.value = statisticData.total - total
        result.push(others)
      }
    }
  }

  return result
}
